export default () => ({

    total_tags: 0,

    min_count: 3,

    show_all_tags: false,

    more_tags_count: 0,

    init(){

        // noinspection JSUnresolvedReference
        this.total_tags = parseInt(this.$root.dataset.totalTags);

        // noinspection JSUnresolvedReference
        this.min_count = parseInt(this.$root.dataset.minCount);

        this.more_tags_count = this.total_tags - this.min_count;
    },

    expandTags(){
        this.show_all_tags = true;
    }

});
